/**
 * Import Lib & assets
 */

import React, { useState, useEffect } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import t from "theme";

/**
 * import components
 */
import { Button__radio } from "components/button/button";

/**
 * styled components
 */

const Radio = styled.div``;
const Button = styled(Button__radio)`
  max-width: 400px;
  padding: 9px 25px;
`;

/**
 * radio component is..
 */

const Form__radio = ({ answers, updateValue, filled = undefined, className }) => {
  const [selected, setSelected] = useState(filled);
  useEffect(() => {
    if (selected) {
      updateValue(selected);
    }
  }, [selected]);
  return (
    <Radio className={className}>
      {answers.map(answer => {
        const { title, id } = answer;
        return (
          <Button
            key={id}
            onClick={() => setSelected(id)}
            title={title}
            selected={selected === id}
          />
        );
      })}
    </Radio>
  );
};

export default Form__radio;

Form__radio.propTypes = {
  /**
      Function to trigger when new radio selected
      */
  updateValue: PropTypes.func.isRequired,
};
